import raissaVideo from '../assets/videos/raissa-depoimento.mp4';

export const videos = [
  {
    id: 1,
    youtubeId: '2RvzFgTY8Y4',
    name: 'Bruna',
    sector: 'Amiga Odonto · Dentista',
    thumbnail: 'cases-assets/fotos/bruna.jpg',
  },
  {
    id: 2,
    youtubeId: 'TnfQkcV_1zE',
    name: 'Vítor Moreira',
    sector: 'Lavanderia · Indústria',
    thumbnail: 'cases-assets/fotos/video-victor.jpg',
  },
  {
    id: 3,
    youtubeId: 'AThY0hB-hpg',
    name: 'Regiane',
    sector: 'Padaria',
    thumbnail: 'cases-assets/fotos/video-regiane.jpg',
  },
  {
    id: 4,
    youtubeId: 'e6Y2ouhKedU',
    name: 'Danielle',
    sector: 'Grupo Ramote',
    thumbnail: 'cases-assets/fotos/danielle.jpg',
  },
  {
    id: 5,
    youtubeId: 'PALgYqOg4uk',
    name: 'Vinícius',
    sector: 'Restaurante Estação',
    thumbnail: 'cases-assets/fotos/vinicius.jpg',
  },
  {
    id: 6,
    videoSrc: raissaVideo,
    name: 'Dra. Raissa Pinheiro',
    sector: 'Dentista e Empresária',
    thumbnail: 'cases-assets/fotos/raissa.jpg',
  },
];
